export const COURSE_FEATURE_KEY = 'course';
